import React from 'react';
import { useIntl } from 'react-intl';

export default ({ yes, notRequired = false }) => {
  const { formatMessage } = useIntl();

  return yes ? (
    <span className="icon-ok">
      {formatMessage({ id: 'yes', defaultMessage: 'Yes' })}
    </span>
  ) : notRequired ? (
    <span className="icon-block">
      {formatMessage({ id: 'not-required', defaultMessage: 'Not required' })}
    </span>
  ) : (
    <span className="icon-block">
      {formatMessage({ id: 'no', defaultMessage: 'No' })}
    </span>
  );
};
